import { store } from '@/store'
import { assetApi } from '@/store/services'
import { toOptions } from '@/utils'
import { useEffect, useState } from 'react'
import { createSearchParams } from 'react-router-dom'
import { AsyncPaginate } from 'react-select-async-paginate'
import { SelectWrapper } from '../wrapper'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

export const AssetSelector = ({ value, onChange }) => {
  const { t } = useTranslation()
  const [selectedOption, setSelectedOption] = useState({})
  const loadOptions = async (search, _loadedOptions, { page }) => {
    const searchParams = createSearchParams({
      page,
      q: search,
      'order[field]': 'vehicle_patent',
      'order[sort]': 'asc'
    }).toString()

    const { assets, meta } = await store.dispatch(
      assetApi.endpoints.getAssets.initiate(`?${searchParams}`, { subscribe: true })
    ).unwrap()

    const options = toOptions({ data: assets })
    const hasMore = page < meta.pagination.total_pages

    return {
      options,
      hasMore,
      additional: {
        page: page + 1
      }
    }
  }

  const getCurrentAsset = async (id) => {
    const { asset = {} } = await store.dispatch(
      assetApi.endpoints.getAsset.initiate(id)
    ).unwrap()

    setSelectedOption({ value: asset.id, label: asset.name })
  }

  // Si el selector esta en un popover o modal, se pierde el selectedOption
  // Esta es una forma para rescatarlo si es que se pierde el estado.
  useEffect(() => {
    if (!value) {
      setSelectedOption({})
      return
    }
    if (value === selectedOption.value) return

    getCurrentAsset(value)
  }, [value])

  const handleChange = (option = {}) => {
    setSelectedOption(option)
    onChange(option)
  }

  return (
    <SelectWrapper label={t('asset.one')}>
      {(styles) => (
        <AsyncPaginate
          loadingMessage={() => t('select.loading')}
          value={selectedOption?.value ? selectedOption : null}
          debounceTimeout={600}
          placeholder={t('select.one')}
          onChange={handleChange}
          loadOptions={loadOptions}
          styles={styles}
          menuPortalTarget={document.body}
          isClearable
          additional={{
            page: 1
          }}
        />
      )
      }
    </SelectWrapper>
  )
}

AssetSelector.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.number
}
